import { BFLType, ModuleTypeId } from "../../types/DBTables";
import { IGlobalData } from "../../types/globalData";
import { IBIMHandler } from "./bimHandler";
import { IModuleRound, IRoundHandler } from "../roundHandler";
//import { IModuleVattenburetSekundärsystem } from "../../types/ModuleDatas";

import bflHelper from "./bflHelper";
import { IBFModule, IBFResult, IKontrollResultRow, IKontrollResultRowDriftoptimering } from "../../types/BFL/Funktionskontroll";
import { IPeriod, VeckoSchemaPerioder, WeekDayName } from "../../types/module-type";
import { IJ3_FX_F_BFData } from "../../types/BFDatas";
import { IModuleByggnadsdata, IModuleVentilationFXochF, IModuleVentilationRoundTidskanaler, IModuleVärmePrimärPump } from "../../types/ModuleDatas";
import notify from "devextreme/ui/notify";
import { compareNärvaroOchDrift, dayNameTranslation, minutesToString, sumSchedule } from "../TimePeriods";
import { numFrmt0Dec } from "../common";

//todo -> make class?!
export const bfl_J3_FX_F = (): IBFModule => {
  const bfName = BFLType.BFL_J3_FX_F;
  const getResult = (module: IModuleRound, bimHandler: IBIMHandler, roundHandler: IRoundHandler, globalData: IGlobalData, formData: any): IBFResult => {
    try {
      let funktionsKontroller: IKontrollResultRow[] = [];
      let driftOptimeringar: IKontrollResultRowDriftoptimering[] = [];
      const debug = {} as any;

      const byggnadsModule = roundHandler.getRoundData()?.data.modules.find((m) => m.moduleTypeId === ModuleTypeId.Byggnadsdata);
      const byggnadModuleData = byggnadsModule?.data as IModuleByggnadsdata;
      const moduleData = module.data as IModuleVentilationFXochF;
      const moduleDataPump = module.data as IModuleVärmePrimärPump;
      formData = (formData?.data || module.bfs?.BFL_J3_FX_F?.data) as IJ3_FX_F_BFData | undefined;

      const ärVentilationStoppad = moduleData.ventilationStoppadPeriodvis === "Ja";
      moduleData.antalVeckorVentilationStoppadPerÅr = (ärVentilationStoppad && moduleData.antalVeckorVentilationStoppadPerÅr) || 0;

      const isFX = module.moduleTypeId === ModuleTypeId.VentilationFX;

      const BIM_DensitetLuft = globalData.System.mapSystemParametrar.BIM_DensitetLuft;
      const BIM_Luft_Energimängd = globalData.System.mapSystemParametrar.BIM_Luft_Energimängd;
      const BIM_GradtimmarVärmeFörOrten = bimHandler.BIM_GradtimmarVärmeFörOrten;
      const BIM_Gradtimmar_Kyla_Orten = bimHandler.BIM_Gradtimmar_Kyla_Orten;
      const BIM_NormalårsTemperatur = bimHandler.normalårsTemperatur;
      const BIM_TimmarPerGrad_Värme = bimHandler.BIM_TimmarPerGrad_Värme;
      const BIM_Vägledande_VerkninsgradAktuellVärmekälla = bimHandler.BIM_Vägledande_VerkninsgradAktuellVärmekälla;

      let dbgBIM = { BIM_DensitetLuft, BIM_Luft_Energimängd, BIM_GradtimmarVärmeFörOrten, BIM_Gradtimmar_Kyla_Orten, BIM_NormalårsTemperatur, BIM_TimmarPerGrad_Värme };

      let data = {
        roundTidsKanaler: {} as any,
        export: {
          årligEnergiFörlust: 0,
        },
      };
      if (module.data.tidsKanaler) {
        Object.keys(module.data.tidsKanaler).forEach((k) => {
          data.roundTidsKanaler[k] = copyTidsSchema(module.data.tidsKanaler[k]);
        });
      }

      //const tidsKanaler = frmData?.tidsKanaler || moduleData.tidsKanaler;
      let tidsKanalerComp: any = undefined;
      if (moduleData.tidsKanaler) {
        // moduleData.tidsKanaler.närvaro = moduleData.tidsKanaler?.närvaro; //Närvaro kommer alltid från ronderingen!
        tidsKanalerComp = compareNärvaroOchDrift(moduleData.tidsKanaler?.närvaro, moduleData.tidsKanaler.ventilation);
      }

      let tidsKanalerCompNyaTider: any = undefined;
      if (formData?.tidsKanaler?.ventilation) {
        formData.tidsKanaler.närvaro = moduleData.tidsKanaler?.närvaro; //Närvaro kommer alltid från ronderingen!
        tidsKanalerCompNyaTider = compareNärvaroOchDrift(formData.tidsKanaler?.närvaro, formData.tidsKanaler.ventilation);
      }

      if (moduleData?.tidsKanaler?.ventilation) {
        debug["Summor veckoscheman (minuter)"] = {
          Närvaro: minutesToString(sumSchedule(moduleData.tidsKanaler.närvaro as VeckoSchemaPerioder, undefined)),
          Ventilation: minutesToString(sumSchedule(moduleData.tidsKanaler.ventilation as VeckoSchemaPerioder, undefined)),
          "Ventilation Helfart": minutesToString(sumSchedule(moduleData.tidsKanaler.ventilation as VeckoSchemaPerioder, "Helfart")),
          "Ventilation Delfart": minutesToString(sumSchedule(moduleData.tidsKanaler.ventilation as VeckoSchemaPerioder, "Delfart")),
        };
      }
      if (formData?.tidsKanaler?.ventilation) {
        debug["Summor veckoscheman, nya tider (minuter)"] = {
          Närvaro: minutesToString(sumSchedule(formData.tidsKanaler.närvaro as VeckoSchemaPerioder, undefined)),
          Ventilation: minutesToString(sumSchedule(formData.tidsKanaler.ventilation as VeckoSchemaPerioder, undefined)),
          "Ventilation Helfart": minutesToString(sumSchedule(formData.tidsKanaler.ventilation as VeckoSchemaPerioder, "Helfart")),
          "Ventilation Delfart": minutesToString(sumSchedule(formData.tidsKanaler.ventilation as VeckoSchemaPerioder, "Delfart")),
        };
      }

      if (moduleData.tidsKanaler?.ventilation && moduleData?.tidsKanaler?.närvaro) {
        const dbgDagar = {} as any;
        Object.keys(tidsKanalerComp).forEach((e) => {
          const wdEntry = tidsKanalerComp[e];
          if (wdEntry.närvaroEjTäckt) dbgDagar[dayNameTranslation[e as WeekDayName] + "-Närvaro ej täckt"] = minutesToString(wdEntry.närvaroEjTäckt);
          if (wdEntry.excessiveVentilation) dbgDagar[dayNameTranslation[e as WeekDayName] + "-Ventilation utanför närvaro"] = minutesToString(wdEntry.excessiveVentilation);
        });
        debug["Kontroll veckodagar"] = dbgDagar;
      }
      if (formData?.tidsKanaler?.ventilation && moduleData?.tidsKanaler?.närvaro) {
        const dbgDagar = {} as any;
        Object.keys(tidsKanalerCompNyaTider).forEach((e) => {
          const wdEntry = tidsKanalerCompNyaTider[e];
          if (wdEntry.närvaroEjTäckt) dbgDagar[dayNameTranslation[e as WeekDayName] + "-Närvaro ej täckt"] = minutesToString(wdEntry.närvaroEjTäckt);
          if (wdEntry.excessiveVentilation) dbgDagar[dayNameTranslation[e as WeekDayName] + "-Ventilation utanför närvaro"] = minutesToString(wdEntry.excessiveVentilation);
        });
        debug["Kontroll veckodagar, nya tider"] = dbgDagar;
      }

      const timmarHelår = 24 * 365;
      const timmarVecka = 24 * 7;
      const veckorPerÅr = timmarHelår / timmarVecka;

      //Tabell 1
      const calcTabell1BasedOnTidskanaler = (
        minuterHelfart: number = 0,
        minuterDelfart: number = 0
        // tidsKanaler?: IModuleVentilationRoundTidskanaler | undefined,
        // helfartAvdrag?: number | undefined,
        // delfartAvdrag?: number | undefined
      ) => {
        // if (!tidsKanaler) return undefined;
        // if (!tidsKanaler.ventilation) return undefined;
        // if (!tidsKanaler.närvaro) return undefined;

        let fxJ3FlödeFrånluftHelfart = moduleData.flödeFrånluft;
        if (moduleData.flödeEnhet === "Kubikmeter per timme (m³/h)") fxJ3FlödeFrånluftHelfart = fxJ3FlödeFrånluftHelfart / 3.6;
        if (moduleData.flödeUppgift === "Uppgift saknas") {
          if (moduleData.flödesKanalForm === "Cirkulära") {
            const schablonCirkRow = globalData.Ventilation.KanalstorlekCirkulära.find((r) => r.KanalstorlekCirkulära === Number(moduleData.flödeFrånluftDiameter));
            fxJ3FlödeFrånluftHelfart = schablonCirkRow ? schablonCirkRow.LiterPerSekund : 0;
          } else {
            const schablonCirkRekt = globalData.Ventilation.KanalstorlekRektangulära.find((r) => r.KanalstorlekRektangulära === moduleData.flödeKanalstorlekBxH);
            fxJ3FlödeFrånluftHelfart = schablonCirkRekt ? schablonCirkRekt.LiterPerSekund : 0;
          }
        }

        // let minuterHelfart = 0;
        // let minuterDelfart = 0;
        // if (tidsKanaler) {
        //   if (helfartAvdrag) {
        //     minuterHelfart = sumSchedule(tidsKanaler.ventilation as VeckoSchemaPerioder, "Helfart");
        //     minuterHelfart = minuterHelfart - helfartAvdrag;
        //   } else {
        //     minuterHelfart = sumSchedule(tidsKanaler.ventilation as VeckoSchemaPerioder, "Helfart");
        //   }
        //   if (delfartAvdrag) {
        //     minuterDelfart = sumSchedule(tidsKanaler.ventilation as VeckoSchemaPerioder, "Delfart") - delfartAvdrag;
        //   } else {
        //     minuterDelfart = sumSchedule(tidsKanaler.ventilation as VeckoSchemaPerioder, "Delfart");
        //   }
        // }
        // const minuterDelfart = tidsKanaler ? sumSchedule(tidsKanaler.ventilation as VeckoSchemaPerioder, "Delfart") : 0;
        // const minuterHelfart = tidsKanaler?.ventilation ? sumSchedule(tidsKanaler.ventilation as VeckoSchemaPerioder, "Helfart") : 0; //

        const fxJ3AnvänderDelfart = minuterDelfart > 0 ? "Ja" : "Nej";

        const reduceratFlödeFlödesreglering =
          moduleData.harReduceradeLuftflödeFlödesreglering === "Ja" && moduleData.reduceratFlödeFlödesreglering ? moduleData.reduceratFlödeFlödesreglering : 0;
        const reduceratFlödeTryckreglering =
          moduleData.harReduceradeLuftflödeTryckreglering === "Ja" && moduleData.reduceratFlödeTryckreglering ? moduleData.reduceratFlödeTryckreglering : 0;

        const fxJ3FlödeDelfart = fxJ3AnvänderDelfart === "Ja" ? Math.max(reduceratFlödeFlödesreglering, reduceratFlödeTryckreglering) / 100 : 0;
        const fxJ3FlödeDelfartLiterPerMinut = fxJ3FlödeDelfart * fxJ3FlödeFrånluftHelfart;

        let fxJ3motorEffekt = 0;
        switch (moduleData.motoreffektUppgift) {
          case "Uppmätt värde":
            fxJ3motorEffekt = moduleData.motoreffektFrånluft;
            break;
          case "Driftsättningsprotokoll":
            fxJ3motorEffekt = moduleData.motoreffektFrånluft;
            break;
          case "Märkskylt nominell effekt":
            fxJ3motorEffekt = moduleData.motoreffektFrånluft * 0.8;
            break;
          case "Uppgift saknas":
            const sfp = isFX ? 1 : 0.6;
            fxJ3motorEffekt = sfp * (fxJ3FlödeFrånluftHelfart / 1000);

            break;
          default:
            throw new Error("Okänt val motoreffektUppgift: " + moduleData.motoreffektUppgift);
        }

        //moduleData.driftÅretRunt === "Ja" ? 8760 :
        const fxJ3DrifttidHelfart = ((veckorPerÅr - moduleData.antalVeckorVentilationStoppadPerÅr) * minuterHelfart) / 60;
        const fxJ3DriftFaktorHelfart = fxJ3DrifttidHelfart >= 8760 ? 1 : fxJ3DrifttidHelfart / 8760;

        const fxJ3DrifttidDelfart = ((veckorPerÅr - moduleData.antalVeckorVentilationStoppadPerÅr) * minuterDelfart) / 60;
        const fxJ3DriftFaktorDelfart = fxJ3DrifttidDelfart >= 8760 ? 1 : fxJ3DrifttidDelfart / 8760;

        const driftFaktorOmÅretruntDrift = moduleData.driftÅretRunt === "Ja" ? 0 : 0;

        const fxJ3VärmeFörlustFFPerÅr =
          (fxJ3FlödeFrånluftHelfart / 1000) * BIM_DensitetLuft * BIM_Luft_Energimängd * BIM_GradtimmarVärmeFörOrten * Math.max(fxJ3DriftFaktorHelfart, driftFaktorOmÅretruntDrift) +
          (fxJ3FlödeFrånluftHelfart / 1000) *
            fxJ3FlödeDelfart *
            BIM_DensitetLuft *
            BIM_Luft_Energimängd *
            BIM_GradtimmarVärmeFörOrten *
            Math.max(fxJ3DriftFaktorDelfart, driftFaktorOmÅretruntDrift); // ((fxJ3FlödeFrånluftHelfart/1000)*BIM_DensitetLuft*BIM_Luft_Energimängd*BIM_GradtimmarVärmeFörOrten*MAX(fxJ3DriftFaktorHelfart;driftFaktorOmÅretruntDrift)+(fxJ3FlödeFrånluftHelfart/1000)*fxJ3FlödeDelfart*BIM_DensitetLuft*BIM_Luft_Energimängd*BIM_GradtimmarVärmeFörOrten*MAX(fxJ3DriftFaktorDelfart;driftFaktorOmÅretruntDrift))

        let fxVärmeFörlustAktuelltSystemPerÅr = 0;
        if (!isFX) {
          fxVärmeFörlustAktuelltSystemPerÅr = fxJ3VärmeFörlustFFPerÅr;
        } else {
          const systemTyp = moduleData.systemTyp;
          const värmeKällaRow = globalData.Byggnadsdata.Värmekälla.find((r) => r.Värmekälla === systemTyp);
          //=IF(rond312ProdVärmeTillLokalerJaNej="Ja";1;0)
          const prodVärmeTillLokaler = moduleDataPump.harProduktionVärme === "Ja" ? 1 : 0;
          if (värmeKällaRow) {
            //((fxJ3VärmeFörlustFFPerÅr*row.energitäckningsgrad)/row.COP)+fxJ3VärmeFörlustFFPerÅr*(1-row.energitäckningsgrad)
            // if (prodVärmeTillLokaler === 1) {
            // } else {
            //   fxVärmeFörlustAktuelltSystemPerÅr = 0;
            // }
            fxVärmeFörlustAktuelltSystemPerÅr =
              (fxJ3VärmeFörlustFFPerÅr * värmeKällaRow.Energitäckningsgrad) / värmeKällaRow.COP + fxJ3VärmeFörlustFFPerÅr * (1 - värmeKällaRow.Energitäckningsgrad);
          }
        }
        const fxJ3EnergianvändningFläkt = fxJ3motorEffekt * fxJ3DrifttidHelfart + fxJ3motorEffekt * 0.5 * fxJ3DrifttidDelfart;

        // let närvarotid =
        //   ((veckorPerÅr - moduleData.antalVeckorVentilationStoppadPerÅr) * (tidsKanaler?.närvaro ? sumSchedule(tidsKanaler.närvaro as VeckoSchemaPerioder, undefined) : 0)) / 60;
        // if (moduleData.driftÅretRunt === "Ja") närvarotid = 8760;
        // const närvarotidInklFörOEfterVädring =
        //   globalData.Ventilation.AcceptabelFörOEfterVädringPerDag.reduce((agg, r) => agg + r.Timmar, 0) * (veckorPerÅr - moduleData.antalVeckorVentilationStoppadPerÅr) + närvarotid;
        // const fxJ3driftFaktor3HelPlusDelfart = fxJ3DrifttidHelfart + fxJ3DrifttidDelfart >= 8760 ? 1 : (fxJ3DrifttidHelfart + fxJ3DrifttidDelfart) / 8760;

        // const driftFaktor4FörVerksamhetensBehov = närvarotid >= 8760 ? 1 : närvarotid / 8760;
        // const fxJ3driftFaktor5FörVerksamhetensBehovInklFörOEfterVädring = närvarotidInklFörOEfterVädring / 8760;

        const tabell1 = {
          fxJ3FlödeFrånluftHelfart,
          fxJ3AnvänderDelfart,
          fxJ3FlödeDelfart,
          fxJ3DrifttidHelfart,
          fxJ3DriftFaktorHelfart,
          fxJ3DrifttidDelfart,
          fxJ3DriftFaktorDelfart,
          fxJ3VärmeFörlustFFPerÅr,
          fxVärmeFörlustAktuelltSystemPerÅr,

          fxJ3motorEffekt,
          fxJ3EnergianvändningFläkt,

          // närvarotid,
          // närvarotidInklFörOEfterVädring,
          // driftFaktor4FörVerksamhetensBehov,
          //fxJ3driftFaktor3HelPlusDelfart,
          //fxJ3driftFaktor5FörVerksamhetensBehovInklFörOEfterVädring,
        };

        return tabell1;
      };

      let tabell1 = undefined;
      let tabell1Nyatider = undefined;
      let minuterHelfart = 0;
      let minuterDelfart = 0;

      if (moduleData.driftÅretRunt === "Ja") {
        const minuterPerVecka = (timmarHelår * 60) / veckorPerÅr; //8760 timmar * 60 minuter / veckor per år
        const deltidsFaktor = moduleData.delfartsFaktor ? moduleData.delfartsFaktor / 100 : 0;
        minuterHelfart = minuterPerVecka * (1 - deltidsFaktor);
        minuterDelfart = minuterPerVecka * deltidsFaktor;

        tabell1 = calcTabell1BasedOnTidskanaler(minuterHelfart, minuterDelfart);
      } else {
        minuterHelfart = sumSchedule(moduleData?.tidsKanaler?.ventilation as VeckoSchemaPerioder, "Helfart");
        minuterDelfart = sumSchedule(moduleData?.tidsKanaler?.ventilation as VeckoSchemaPerioder, "Delfart");
        tabell1 = calcTabell1BasedOnTidskanaler(minuterHelfart, minuterDelfart); //moduleData.tidsKanaler

        let tidsKanaler = formData?.tidsKanaler || moduleData?.tidsKanaler;
        minuterHelfart = sumSchedule(tidsKanaler?.ventilation as VeckoSchemaPerioder, "Helfart");
        minuterDelfart = sumSchedule(tidsKanaler?.ventilation as VeckoSchemaPerioder, "Delfart");
        tabell1Nyatider = calcTabell1BasedOnTidskanaler(minuterHelfart, minuterDelfart);
      }

      //const tabell1Nyatider = calcTabell1BasedOnTidskanaler(module.bfs.BFL_J3_FX_F?.data.tidsKanaler);
      // if (moduleData.driftÅretRunt !== "Ja") {
      //   tabell1Nyatider = calcTabell1BasedOnTidskanaler(formData?.tidsKanaler || moduleData.tidsKanaler);
      // }

      debug["Grundvärden"] = dbgBIM;
      debug["Tabell 1 (B17:B38)"] = tabell1;
      debug["Tabell 1 Nyatider"] = tabell1Nyatider;

      const fxJ3GradtimmarFörOrten = BIM_GradtimmarVärmeFörOrten;

      const energikälla = byggnadModuleData.energikälla;
      const energiKällaRow = globalData.Byggnadsdata.Värmekälla.find((r) => r.Värmekälla === energikälla);
      const energiSlag = energiKällaRow ? energiKällaRow.Energislag : "?";
      const verkningsGrad = BIM_Vägledande_VerkninsgradAktuellVärmekälla;

      const {
        fxJ3motorEffekt,
        fxJ3VärmeFörlustFFPerÅr,
        fxVärmeFörlustAktuelltSystemPerÅr,
        fxJ3EnergianvändningFläkt,
        //fxJ3driftFaktor3HelPlusDelfart,
        //fxJ3driftFaktor5FörVerksamhetensBehovInklFörOEfterVädring,
      } = tabell1 || {
        fxJ3motorEffekt: 0,
        fxJ3VärmeFörlustFFPerÅr: 0,
        fxVärmeFörlustAktuelltSystemPerÅr: 0,
        fxJ3EnergianvändningFläkt: 0,
        //fxJ3driftFaktor3HelPlusDelfart: 0,
        //fxJ3driftFaktor5FörVerksamhetensBehovInklFörOEfterVädring: 0,
      };

      data.export.årligEnergiFörlust = fxVärmeFörlustAktuelltSystemPerÅr;

      debug["More..."] = {
        energikälla,
        energiSlag,
        verkningsGrad,
        fxJ3motorEffekt,
        "Värme förlust aktuellt system  (kWh/år) -> Grunddata BIM Bruttovärde": data.export.årligEnergiFörlust,
      };

      //Försök att bättre beräkna besparingspotential genom att skicka in optimerade värden till beräkning för energianvänding och sedan jämföra med befintliga värden.
      const totalExcessiveVentilationHelfart = Object.keys(tidsKanalerComp).reduce((agg, k) => agg + (tidsKanalerComp[k].excessiveVentilationHelfart || 0), 0);
      const totalExcessiveVentilationDelfart = Object.keys(tidsKanalerComp).reduce((agg, k) => agg + (tidsKanalerComp[k].excessiveVentilationDelfart || 0), 0);
      minuterHelfart = sumSchedule(moduleData?.tidsKanaler?.ventilation as VeckoSchemaPerioder, "Helfart") - totalExcessiveVentilationHelfart;
      minuterDelfart = sumSchedule(moduleData?.tidsKanaler?.ventilation as VeckoSchemaPerioder, "Delfart") - totalExcessiveVentilationDelfart;
      const tabell1Optimerad = calcTabell1BasedOnTidskanaler(minuterHelfart, minuterDelfart);

      const fxJ3VärmeFörlustFFPerÅr_optimerad = tabell1Optimerad.fxJ3VärmeFörlustFFPerÅr;
      const fxVärmeFörlustAktuelltSystemPerÅr_optimerad = tabell1Optimerad.fxJ3EnergianvändningFläkt;

      const optimeradVärmeBrutto = fxJ3VärmeFörlustFFPerÅr - fxJ3VärmeFörlustFFPerÅr_optimerad;
      const optimeradVärmeNetto = optimeradVärmeBrutto / verkningsGrad;
      const optimeradDriftElBrutto = fxJ3EnergianvändningFläkt - fxVärmeFörlustAktuelltSystemPerÅr_optimerad;
      const optimeradDriftElNetto = optimeradDriftElBrutto;

      debug["Besparingspotential om optimerad"] = {
        fxJ3besparingsPotentialVärmeBrutto: optimeradVärmeBrutto,
        fxJ3besparingsPotentialVärmeNetto: optimeradVärmeNetto,
        fxJ3besparingsPotentialDriftElBrutto: optimeradDriftElBrutto,
        fxJ3besparingsPotentialDriftElNetto: optimeradDriftElNetto,
      };

      if (moduleData.driftÅretRunt === "Ja") {
        funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 5, undefined, ""));
      } else {
        if (moduleData.finnsOrsakerTillLångDrifttid === "Ja") {
          if (optimeradVärmeNetto + optimeradDriftElNetto > 0) funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 5, undefined, ""));
        } else {
          if (optimeradVärmeNetto > 0) funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 1, optimeradVärmeNetto, energiSlag));

          if (optimeradDriftElNetto > 0) funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 3, optimeradDriftElNetto, "El"));

          if (optimeradDriftElNetto <= 0) funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 4, undefined, ""));

          //Finns det överventilation för några dagar befintliga dagar?
          const overVentilationVeckodagar = [] as string[];
          Object.keys(tidsKanalerComp).forEach((e) => {
            const wdEntry = tidsKanalerComp[e];
            if (wdEntry.excessiveVentilation) overVentilationVeckodagar.push(dayNameTranslation[e as WeekDayName]);
          });
          if (overVentilationVeckodagar.length)
            funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 14, undefined, "", { formatFn: (v) => overVentilationVeckodagar.join(", ") }));
        }

        //Saknas ventilation för några befintliga dagar?
        const avvikandeVeckodagar = [] as string[];
        if (tidsKanalerComp) {
          Object.keys(tidsKanalerComp).forEach((e) => {
            const wdEntry = tidsKanalerComp[e];
            if (wdEntry.närvaroEjTäckt) avvikandeVeckodagar.push(dayNameTranslation[e as WeekDayName]);
          });
        }

        if (avvikandeVeckodagar.length) funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 13, undefined, "", { formatFn: (v) => avvikandeVeckodagar.join(", ") }));

        if (tabell1Nyatider && formData?.harAngettNyaTidskanaler === "Ja") {
          //Överkonsumtion energi med ny drifttid sorterat per energislag
          const fxJ3VärmeFörlustFFPerÅr_nyatider = tabell1Nyatider.fxJ3VärmeFörlustFFPerÅr;
          const fxVärmeFörlustAktuelltSystemPerÅr_nyatider = tabell1Nyatider.fxJ3EnergianvändningFläkt;

          //Förändring energi med nya drifttider
          const fxJ3DiffNyaTiderVärmeBrutto = fxJ3VärmeFörlustFFPerÅr_nyatider - fxJ3VärmeFörlustFFPerÅr;
          const fxJ3DiffNyaTiderVärmeNetto = fxJ3DiffNyaTiderVärmeBrutto / verkningsGrad;

          const fxJ3DiffNyaTiderDriftElBrutto = fxVärmeFörlustAktuelltSystemPerÅr_nyatider - fxJ3EnergianvändningFläkt;
          const fxJ3DiffNyaTiderDriftElNetto = fxJ3DiffNyaTiderDriftElBrutto;

          debug["Förändring energi med nya drifttider"] = {
            fxJ3DiffNyaTiderVärmeBrutto,
            fxJ3DiffNyaTiderVärmeNetto,
            fxJ3DiffNyaTiderDriftElBrutto,
            fxJ3DiffNyaTiderDriftElNetto,
          };

          if (fxJ3DiffNyaTiderVärmeNetto > 0) driftOptimeringar.push(roundHandler.getDriftoptimering(bfName, 6, fxJ3DiffNyaTiderVärmeNetto, energiSlag));

          if (fxJ3DiffNyaTiderDriftElNetto > 0) driftOptimeringar.push(roundHandler.getDriftoptimering(bfName, 8, fxJ3DiffNyaTiderDriftElNetto, "El"));

          if (fxJ3DiffNyaTiderVärmeNetto < 0 && moduleData.driftÅretRunt === "Nej" && formData?.harAngettNyaTidskanaler === "Ja")
            driftOptimeringar.push(roundHandler.getDriftoptimering(bfName, 9, -fxJ3DiffNyaTiderVärmeNetto, energiSlag));

          if (fxJ3DiffNyaTiderDriftElNetto < 0 && moduleData.driftÅretRunt === "Nej" && formData?.harAngettNyaTidskanaler === "Ja")
            driftOptimeringar.push(roundHandler.getDriftoptimering(bfName, 11, -fxJ3DiffNyaTiderDriftElNetto, "El"));

          //Saknas ventilation för några nya dagar?
          const avvikandeVeckodagarNyaTider = [] as string[];
          if (tidsKanalerCompNyaTider) {
            Object.keys(tidsKanalerCompNyaTider).forEach((e) => {
              const wdEntry = tidsKanalerCompNyaTider[e];
              if (wdEntry.närvaroEjTäckt) avvikandeVeckodagarNyaTider.push(dayNameTranslation[e as WeekDayName]);
            });
          }

          if (avvikandeVeckodagarNyaTider.length)
            driftOptimeringar.push(roundHandler.getDriftoptimering(bfName, 12, undefined, "", { formatFn: (v) => avvikandeVeckodagarNyaTider.join(", ") }));

          //Finns det överventilation för några dagar nya dagar?
          const overVentilationVeckodagarNyaTider = [] as string[];
          Object.keys(tidsKanalerCompNyaTider).forEach((e) => {
            const wdEntry = tidsKanalerCompNyaTider[e];
            if (wdEntry.excessiveVentilation) overVentilationVeckodagarNyaTider.push(dayNameTranslation[e as WeekDayName]);
          });

          if (overVentilationVeckodagarNyaTider.length)
            driftOptimeringar.push(roundHandler.getDriftoptimering(bfName, 15, undefined, "", { formatFn: (v) => overVentilationVeckodagarNyaTider.join(", ") }));
        }
      }

      const bH = bflHelper.bflHelper();

      return {
        bfName: BFLType.BFL_J3_FX_F,
        funktionsKontroller: bH.cleanFunktionsKontroller(funktionsKontroller),
        driftOptimeringar: bH.cleanDriftoptimeringar(driftOptimeringar),
        data,
        debug,
        note: "",
      };
    } catch (err: any) {
      return {
        bfName,
        funktionsKontroller: [],
        driftOptimeringar: [],
        note: "",
        data: {},
        debug: { Error: err },
        error: err,
      };
    }
  };

  const copyTidsSchema = (schema: VeckoSchemaPerioder): VeckoSchemaPerioder => {
    const res: Partial<VeckoSchemaPerioder> = {};
    Object.keys(WeekDayName).forEach((wd: string) => {
      res[wd as WeekDayName] = schema[wd as WeekDayName]?.slice();
    });

    return res;
  };

  /// transfers any formdata values to the bfl Result. bfl will be exposed to binding the form
  const bflSpecificPrepareData = (module: IModuleRound, bfl: IBFResult, bflForm: IBFResult | undefined) => {
    if (!bfl.data) bfl.data = {};
    if (bflForm?.data?.tidsKanaler) {
      bfl.data.tidsKanaler = bflForm.data.tidsKanaler;
    }
    if ((!bfl.data.tidsKanaler || !bfl.data.tidsKanaler.närvaro || !bfl.data.tidsKanaler.ventilation) && module.data.tidsKanaler) {
      bfl.data.tidsKanaler = {};
      Object.keys(module.data.tidsKanaler).forEach((k) => {
        bfl.data.tidsKanaler[k] = copyTidsSchema(module.data.tidsKanaler[k]);
      });
    }
    bfl.data.harAngettNyaTidskanaler = bflForm?.data?.harAngettNyaTidskanaler;
  };

  return { getResult, bflSpecificPrepareData, bfName };
};

const dflt = { bfl_J3_FX_F };

export default dflt;
